import React from "react";
import styled from "styled-components";
import { FormRow, FormRowLabel, FormTextbox, TitleStack, BlockButton, Form, FormRowMessage, Card } from "fiver-react-ui-components";
const StyledWrapper = styled.div``;

const ConfirmStep = ({
  translations,
  isSubmitting,
  onStepClicked,
  isStepValid,
  values,
  dirty,
  signupError,
  forcedCountryCode
}) => {
  const defaultSignupFields = [{
    field: "email",
    label: translations.email
  }, {
    field: "firstName",
    label: translations.firstName
  }, {
    field: "lastName",
    label: translations.lastName
  }, {
    field: "username",
    label: translations.username
  }, {
    field: "birthDate",
    label: translations.birthDate
  }, {
    field: "mobileNumber",
    label: translations.mobileNumber
  }, {
    field: "street1",
    label: "Address Line 1"
  }, {
    field: "street2",
    label: "Address Line 2"
  }, {
    field: "city",
    label: "City / Town"
  }, {
    field: "county",
    label: "County / State"
  }];
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(TitleStack, {
    title: translations.signupConfirmation,
    subtitle: translations.signupConfirmationMessage,
    id: "step-title"
  }), /*#__PURE__*/React.createElement(Form, null, defaultSignupFields.map(item => {
    return values[item.field] ? /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormRowLabel, {
      id: item.label
    }, item.label), /*#__PURE__*/React.createElement(FormTextbox, {
      prefix: item.field === "mobileNumber" ? `+${forcedCountryCode}` : null,
      id: item.label + "-field",
      style: {
        paddingLeft: "1rem"
      },
      value: values[item.field],
      isReadOnly: true
    })) : null;
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    margin: "0 0 1rem",
    isVisible: signupError !== undefined,
    id: "signup-error"
  }, signupError), /*#__PURE__*/React.createElement(BlockButton, {
    type: "submit",
    isLoading: isSubmitting,
    disabled: !isStepValid || !dirty,
    style: {
      marginBottom: "1rem"
    },
    id: "submit-btn"
  }, translations.finish), /*#__PURE__*/React.createElement(BlockButton, {
    onClick: () => onStepClicked(3),
    id: "back-btn"
  }, translations.edit)));
};

export default ConfirmStep;